/**
 * 预请求, 计算签名  使用了阿里api网关 相关文档： https://help.aliyun.com/document_detail/29475.html?spm=a2c4g.11186623.2.22.6a2f1f7fWre3qE
 */

import crypto from 'crypto-js';
import config from '@/config';
import { startsWith } from '@/utils';

const key = config.gateway.key;
const secret = config.gateway.secret;
const uuid = require('uuid');

export default function gateway(request) {
	// console.log('request', request);
	let url = request.url;
	let host = url.match(/^http(s)?:\/\/(.*?)\//)[2];
	let md5 = '';
	let timestamp = +new Date();
	let nonce = uuid.v4();
	// 定义非自定义的文本签名.包括请:求方法、 headers.accept 、请求数据body.md5和 headers.content-type
	let textToSign = '';
	textToSign += request.method.toUpperCase() + '\n';
	textToSign += request.headers['Accept'] + '\n';
	textToSign += md5 + '\n';
	textToSign +=
		request.method.toLowerCase() === 'post'
			? request.headers['Content-Type'] + '\n'
			: '\n';
	textToSign += '\n';
	let headers = headersToSign(request, nonce);
	let signatureHeaders;
	let sortedKeys = Array.from(headers.keys()).sort();

	for (let headerName of sortedKeys) {
		textToSign += headerName + ':' + headers.get(headerName) + '\n';
		signatureHeaders = signatureHeaders
			? signatureHeaders + ',' + headerName
			: headerName;
	}
	// 获取到最终的需要签名的字符串
	textToSign += urlToSign(request, host);
	// console.log(textToSign);

	let hash = crypto.HmacSHA256(textToSign, secret);
	// console.log('hash:' + hash);
	let signature = hash.toString(crypto.enc.Base64);
	// console.log('signature:' + signature);

	return {
		signature,
		signatureHeaders,
		nonce,
		timestamp,
		key
	};
}

/**
 * 对请求头进行签名
 */
function headersToSign(request, nonce) {
	let headers = new Map();
	for (let name in request.headers) {
		name = name.toLowerCase();
		if (!startsWith(name, 'x-ca-')) {
			continue;
		}
		if (
			name === 'x-ca-signature' ||
			name === 'x-ca-signature-headers' ||
			name == 'x-ca-key' ||
			name === 'x-ca-nonce'
		) {
			continue;
		}
		let value = request.headers[name];
		headers.set(name, value);
	}
	headers.set('x-ca-key', key);
	headers.set('x-ca-nonce', nonce);
	return headers;
}

/**
 * 对url进行签名
 */
function urlToSign(request, host) {
	let params = new Map();
	let contentType = request.headers['Content-Type'];

	if (
		contentType &&
		startsWith(contentType, 'application/x-www-form-urlencoded') &&
		request.data
	) {
		let data = request.data;
		const formParams = data.split('&');
		formParams.forEach(p => {
			const ss = p.split('=');
			ss[0] = decodeURIComponent(ss[0]);
			ss[1] = decodeURIComponent(ss[1]);
			params.set(ss[0], ss[1]);
		});
	}
	let requestUrl = request.url;
	// get请求
	if (
		request.method.toLowerCase() === 'get' &&
		request.params &&
		Object.keys(request.params).length
	) {
		// 将params的参数拼到url后面
		requestUrl += '?';
		let getParams = request.params;
		let index = 1;
		for (let k in request.params) {
			let keyValue = '';
			/**
			 * 参数分为三种类型
			 * 1. 数组
			 * 2. 对象
			 * 3. 基本
			 */
			if (Array.isArray(getParams[k])) {
				keyValue = arrayParam(k, getParams[k]);
			} else {
				keyValue = `${k}=${getParams[k]}`;
			}
			requestUrl +=
				index === Object.keys(request.params).length
					? keyValue
					: keyValue + '&';
			index++;
		}
	}

	const ss = requestUrl.split('?');

	if (ss.length > 1 && ss[1]) {
		const queryParams = ss[1].split('&');
		queryParams.forEach(p => {
			const ss = p.split('=');
			params.set(ss[0], ss[1]);
		});
	}
	let sortedKeys = Array.from(params.keys());
	sortedKeys.sort();
	let l1 = ss[0].indexOf(host) + host.length;
	let url = ss[0].substring(l1);
	let qs;
	for (let k of sortedKeys) {
		let s = k + '=' + params.get(k);
		qs = qs ? qs + '&' + s : s;
	}
	return qs ? url + '?' + qs : url;
}
/**
 * 对数组进行拼凑,只取第一项
 */
function arrayParam(arrName, arr) {
	return `${arrName}[]=${JSON.stringify(arr[0])}`;
}
